import { persistenceService } from "@repo/core";
import { useEffect } from "react";

export const PersistenceRoute = "pwa_route";
export const PersistenceQuery = "pwa_query";

export const PersistenceCurrency = "pwa_currency";
export const PersistenceApp = "pwa_app";
export const PersistenceOverrideTheme = "pwa_override_theme";
export const PersistenceOverrideConfig = "pwa_override_config";

export const ProgressiveWebApp: React.FC = () => {
    useEffect(() => {
        console.info("Mounted Progressive Web Application - Loading configuration");
        const route = persistenceService.get(PersistenceRoute);
        const query = persistenceService.get(PersistenceQuery);
        const currency = persistenceService.get(PersistenceCurrency);
        const appKey = persistenceService.get(PersistenceApp);

        if (!query && (!currency || !appKey || !route)) {
            throw new Error(
                "Failed to load configuration for Progressive Web Application: currency, key or route is missing. Please uninstall and try re-installing from a valid experience page.",
            );
        }

        const currentUrl = new URL(window.location.href);
        const redirectURL = new URL(
            `${currentUrl.origin}${route === "bundle" ? "/#/bundle/new" : "/#/experience/new"}`,
        );

        if (query) {
            const finalURL = `${redirectURL.toString()}?${query}`;
            window.location.href = finalURL;
        } else {
            // Old case where we need to add params individually. For backwards compatibility.
            const overrideTheme = persistenceService.get(PersistenceOverrideTheme) as string | undefined;
            const overrideConfig = persistenceService.get(PersistenceOverrideConfig) as string | undefined;
            const finalURL = `${redirectURL.toString()}?currencyCode=${currency}&applicationKey=${appKey}${
                overrideTheme ? `&overrideTheme=${overrideTheme}` : ""
            }${overrideConfig ? `&overrideConfig=${overrideConfig}` : ""}`;
            window.location.href = finalURL;
        }
    }, []);
    return <></>;
};
